import { isEmpty } from 'lodash';
// constants
import { scriptTypes } from 'constants/scripts';
// finders
import { findSeasonCodeByDateAndSeasonActivityType } from 'seasons/finders';
// processors
import {
  processProductYears
} from 'settings/processors';
// selectors
import {
  getSeasonActivityTypeForScriptType
} from 'seasons/selectors';
// selectors
import {
  getProductYears
} from 'settings/selectors';

export const findProductYears = ({ dispatch, getState }) => {
  const state = getState();
  const today = new Date().toISOString();


  const productYears = getProductYears(state);
  if (!isEmpty(productYears)) {
    return Promise.resolve(productYears);
  }

  return Promise.all([
    findSeasonCodeByDateAndSeasonActivityType({
      dispatch,
      date: today,
      getState,
      seasonActivityType: getSeasonActivityTypeForScriptType(state, scriptTypes.APPLICATION)
    }),
    findSeasonCodeByDateAndSeasonActivityType({
      dispatch,
      date: today,
      getState,
      seasonActivityType: getSeasonActivityTypeForScriptType(state, scriptTypes.FERTILITY)
    }),
    findSeasonCodeByDateAndSeasonActivityType({
      dispatch,
      date: today,
      getState,
      seasonActivityType: getSeasonActivityTypeForScriptType(state, scriptTypes.PLANTING)
    })
  ])
  .then((rawSeasonCodes) => {
    return processProductYears({ dispatch, getState, rawSeasonCodes });
  });
};

/**
 * @param params.date
 * @param params.scriptType
 */
export const findProductYearForDate = ({ dispatch, getState, params }) => {
  const { date, scriptType } = params;
  return findSeasonCodeByDateAndSeasonActivityType({
    dispatch,
    date,
    getState,
    seasonActivityType: getSeasonActivityTypeForScriptType(getState(), scriptType)
  }).then(seasonCode => parseInt(seasonCode.substr(0,4), 10));
};
